//idiomas com traducao cadastravel: o portugues e o proprio texto original
export const IDIOMAS_TRADUCAO = [
    { codigo: 'en-US', rotulo: 'English (US)' },
    { codigo: 'es', rotulo: 'Español' },
];

//altera um texto de um idioma sem perder os demais
export const alteraTraducao = (traducoes, idioma, campo, valor) => ({
    ...(traducoes || {}),
    [idioma]: { ...((traducoes || {})[idioma] || {}), [campo]: valor },
});
